'use client'

import DisablePrefetchLink from '@component/disablePrefetchLink'
import useFetch from '@hooks/useFetch'
import useLogin from '@hooks/useLogin'
import useTrackSuburb from '@hooks/useTrackSuburb'
import { trackDataLayer } from '@plugin/google/gtm/modules/suburb'
import getRouter, { URLS } from '@router'
import { get } from 'lodash-es'
import { useCallback } from 'react'

export default function TrackSuburb({
  data
}) {

  const dataId = get(data, 'basic.id')
  const { isLogin } = useLogin()
  const { data: status } = useFetch(
    isLogin
      ? { url: 'location/user/state', params: { suburbId: dataId }, cfCache: false }
      : null
  )

  const { suburb, showTrackSuburb } = useTrackSuburb()
  const currentSuburbId = get(suburb, 'basic.id')
  const tracked = get(status, 'tracked', false) || get(currentSuburbId === dataId ? suburb : data, 'basic.tracked', false)

  const manageClick = useCallback(() => {
    trackDataLayer.manage()
  }, [])

  return (
    tracked
      ? <DisablePrefetchLink href={getRouter(URLS.profileTrackedSuburb)} className='button-primary-out w-full md:w-204' onClick={manageClick}>Manage tracked suburbs</DisablePrefetchLink>
      : <button type='button' className='button-orange w-full md:w-204' onClick={showTrackSuburb({ suburb: data, signupSource: 'Track_Suburb' })}>Track this suburb</button>
  )
}